import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ReactElement, ReactNode } from 'react';
import { JSX } from 'react/jsx-runtime';

/** Conditionally wraps elements easily */
export const WrapIf = t0 => {
  const $ = _c(4);
  const {
    if: condition,
    wrap: wrapper,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== condition || $[2] !== wrapper) {
    t1 = condition ? wrapper(children) : <>{children}</>;
    $[0] = children;
    $[1] = condition;
    $[2] = wrapper;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};